/**
 * Parses the JSON from a directive.
 *
 * @param data
 * @param defaults
 * @param targetProperty
 */
export function directiveSettings(data, defaults={}, targetProperty=false) {
    const settings = Object.assign({}, defaults);

    if (data) {
        let parsedData;

        try {
            parsedData = JSON.parse(data);
        } catch (e) {
            parsedData = data;
        }

        if (parsedData instanceof Object && !Array.isArray(parsedData)) {
            Object.assign(settings, parsedData);

        } else if (targetProperty) {
            settings[targetProperty] = parsedData;

        } else {
            console.error(`Error parsing settings: "${data}"`);
        }
    }

    return settings;
}



// WEBPACK FOOTER //
// ./source/scripts/utils/parse.js